module.exports = __webpack_public_path__ + "img/3.7a6d8f71.png";